export const violationsDescriptionListHtml = `
<div style="height:100%;"><%= violationsStat['summ'] %> точек фиксаций. <span class="tooltip-container">ℹ️<span class="tooltip-content">⚠️ Это не количество нарушений, а количество ГЛОНАСС-точек, где зафиксировано нарушение.<br><br> Нарушение — это событие, которое начисляет баллы по своей логике (например, по пройденному расстоянию, скорости или длительности).<br><br>Количество баллов часто не совпадает с числом точек.<br><br>Пример:<br>Машина проехала 10 м с поднятым кузовом при скорости 25 км/ч → расстояние умножается на 5 → 50 м → 5 баллов, но на карте может быть всего 1 точка фиксации.</span></span> Меню для карты:</div>
<div id="violations-setting-list">
  <div class="text-height-0">
    <button type="button" class="btn btn-link py-0 violations-setting-list-checked-all" id="violations-setting-list-checked-all" >
        выбрать все
    </button>
    <button type="button" class="btn btn-link py-0 violations-setting-list-not-checked-all" id="violations-setting-list-not-checked-all" >
        снять все
    </button>
    <button type="button" class="btn btn-link py-0 violations-setting-list-show-drains-and-refueling" id="violations-setting-list-show-drains-and-refueling" data-is-show="1" >
        показать сливы, заправки
    </button>
  </div>
  <input type="text" id="violations-search" class="form-control violations-setting-list-search" placeholder="Поиск по нарушениям">
  
  <table>
    <tbody>
      <% 
        for (let i = 0; i < data.length; i++) {
            let violationId = data[i]['id'];
            let checked = violationId in violationsSetting ? 'checked' : '';
            let violationCnt = violationsStat[violationId] || 0;
            let boldClass = violationCnt ? ' class="font-weight-bold violations-setting-list-tr"' : ' class="violations-setting-list-tr"';
            let arrayData = data[i]['group_ids'];
      %>
        <tr <%= boldClass %>>
          <td>
            <input class="violations-setting-list-checkbox" type="checkbox" <%= checked %> id="<%= violationId %>" data-array="<%= JSON.stringify(arrayData) %>">
          </td>
          <td class="text-right">
            <label class="violations-setting-list-count" for="<%= violationId %>" style="width:100%">
              <%= violationCnt %>
            </label>
          </td>  
          <td>
            <label for="<%= violationId %>" class="violations-setting-list-label"> 
              <%= data[i].description %>
            </label>
          </td>  
        </tr>
      <% } %>
    </tbody>
  </table>
</div>
`;
